import React, { lazy } from 'react';
import { isMobileClient } from 'utils/responsive';

const ZoomPage = lazy(() => import('./zoom'));

const WebinarJoinPage = () => {
  return isMobileClient() ? (
    <p className="mobile-msg">
      Bravely webinars are not supported on mobile, please join on a desktop
      computer.
    </p>
  ) : (
    <ZoomPage />
  );
};

export default WebinarJoinPage;
